<template>
    <div class="about">
        <div class="pg-header">
            <div><label class="title">
                {{ this.filter.state==0?'待接单':'已完成'}}
            </label></div>
            <div class="algr">
                <div class="pg-nav">
                    <i class="icon-home"></i>
                    <span>延续性护理服务</span>|
                    <span>{{ this.filter.state==0?'待接单':'已完成'}}</span>
                </div>
            </div>
        </div>

        <div class="collapse-wrap">
            <div class="search-bar">
                <el-form ref="form" label-width="120px">
                    <div class="def-key">
                        <label>姓名<el-input size="small" maxlength="6" style="width: 80px" v-model.trim="filter.name"
                                @keyup.enter.native="handleFilter(0, $event)"></el-input></label>
                        <label>身份证号<el-input size="small" maxlength="18" style="width: 150px" v-model.trim="filter.cardNum"
                                @keyup.enter.native="handleFilter(1, $event)"></el-input></label>
                        <label>{{ this.filter.state==0?'应服务时间':'实际服务时间'}}
                            <el-date-picker size="small" :default-time="['00:00:00', '23:59:59']" style="width: 220px"
                                type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期"
                                end-placeholder="结束日期" v-model="filter.date" :picker-options="pickerOptions"
                                @change="handleFilter(2, $event)"></el-date-picker>
                        </label>
                        <div style="display: inline-block;">科室
                            <el-select size="small" filterable clearable placeholder="请选择"
                                v-model="filter.departmentId" @change="handleFilter(3, $event)">
                                <el-option v-for="item in deptList" :key="item.id" :label="item.name"
                                    :value="item.id"></el-option>
                            </el-select>
                        </div>
                        <el-button class="flr" size="mini" icon="el-icon-search" round @click="handleFilter">搜索</el-button>
                    </div>
                </el-form>
            </div>

            <div class="table-wrap">
                <el-table ref="multipleTable" header-cell-class-name="tab-cell" cell-class-name="tab-cell" border :data="list.data" v-loading="isLoading">
                    <el-table-column label="姓名" width="120">
                        <template slot-scope="scope"><router-link class="noline" target="_blank" :to="{name: 'Patient/User', query: {patientId: scope.row.patientId,fid:scope.row.recordId,t:3, t6: 6,datasources:scope.row.dataSources}}"><span class="fc key">{{ scope.row.name }}</span></router-link></template>
                    </el-table-column>
                    <el-table-column prop="cardNum" label="身份证号"></el-table-column>
                    <el-table-column prop="sex" label="性别">
                        <template slot-scope="scope">
                            {{{1:'男',2:'女'}[scope.row.sex]}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="age" label="年龄"></el-table-column>
                    <el-table-column prop="diagnosis" label="诊断"></el-table-column>
                    <el-table-column prop="department" label="科室"></el-table-column>
                    <el-table-column prop="serviceType" label="服务项目" width="140"></el-table-column>
                        <el-table-column label="服务人" width="100" v-if="filter.state==0">
                            <template slot-scope="scope">
                                {{ scope.row.expectServicer}}
                            </template>
                        </el-table-column>
                        <el-table-column label="应服务时间" show-overflow-tooltip v-if="filter.state==0">
                            <template  slot-scope="scope">
                                {{scope.row.expectServiceTime}}
                            </template>
                        </el-table-column>
                        <el-table-column label="服务人" width="100" v-if="filter.state==1">
                            <template slot-scope="scope">
                                {{ scope.row.servicer}}
                            </template>
                        </el-table-column>
                        <el-table-column label="实际服务时间" show-overflow-tooltip v-if="filter.state==1">
                            <template  slot-scope="scope">
                                {{scope.row.serviceTime}}
                            </template>
                        </el-table-column>
                    <el-table-column fixed="right" label="操作" width="120" >
                        <template slot-scope="scope">
                            <div class="tab-action">
                                <el-tooltip content="查看" placement="top" :enterable="false"  target="_blank">
                                    <router-link :to="{name: 'Patient/User', query: {patientId: scope.row.patientId,fid:scope.row.recordId,t:3, t6: 6,datasources:scope.row.dataSources}}"><i class="icon-research"></i></router-link>
                                </el-tooltip>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination">
                    <el-row>
                        <el-col :span="12">
                            <div class="record">
                                当前是第<span v-text="(filter.pageNumber - 1) * filter.pageSize + 1"></span>条至第<span v-text="(filter.pageNumber - 1) * filter.pageSize + filter.pageSize
                                    "></span>数据
                            </div>
                            <div class="record">
                                总计<span v-text="list.total"></span>条记录
                            </div>
                        </el-col>
                        <el-col :span="12" style="text-align: right">
                            <el-pagination :disabled="isLoading" layout="sizes, prev, pager, next"
                                :page-sizes="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]" prev-text="上一页" next-text="下一页"
                                :current-page="list.current" :page-size="filter.pageSize" :total="list.total"
                                @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from "@/service/api.js";
import utils from "@/service/utils";
import mixin from "@/views/mixin";
import dayjs from "dayjs";

export default {
    mixins: [mixin],
    data() {
        return {
            list: {
                current: 1,
                total: 0,
                pageSize: 0,
                data: null,
            },
            filter: {
                cardNum:'',
                departmentId:'',
                expectServiceTimeEnd:'',
                expectServiceTimeStart:'',
                name:'',
                state:0,//0:待接单 1:已完成
                pageNumber: 1,
                pageSize: 10,
                
            },
            form: {
                detailId: 0,
                datasources: "",
            },
            options: [
                {
                    name: "引流管",
                    id: 1,
                },
                {
                    name: "PICC",
                    id: 2,
                },
                {
                    name: "输液港",
                    id: 3,
                },
                {
                    name: "透析导管",
                    id: 4,
                },
                {
                    name: "留置尿管",
                    id: 5,
                },
                {
                    name: "留置胃管",
                    id: 6,
                },
                {
                    name: "压力性损伤护理",
                    id: 7,
                },
                {
                    name: "糖尿病足护理",
                    id: 8,
                },
                {
                    name: "造口护理",
                    id: 9,
                },
                {
                    name: "产褥期自我护理",
                    id: 10,
                },
                {
                    name: "新生儿护理",
                    id: 11,
                },
                {
                    name: "产科上门服务",
                    id: 12,
                },
                {
                    name: "线上指导",
                    id: 13,
                },
            ],
            deptList:[],
        };
    },
    created() {
        let query = this.$route.query;
        this.filter.state=query.state;
        this.$watch(
            () => this.$route.query, // 监听的对象是 $route.query
            (newQuery, oldQuery) => {
                this.filter.state=newQuery.state;
                this.filter.expectServiceTimeStart='',
                this.filter.expectServiceTimeEnd='',
                this.filter.departmentId='',
                this.filter.pageNumber=1;
                this.loadList();
            }
        );
        this.loadList();
        // 获取 科室下拉
        api.getDeptDropdown({ departmentType: 0 }).then((res) => {
            if (res.code == 1000 && res.data) {
                this.deptList = res.data;
            }
        });
    },
    mounted() {
        // 监听页面显示隐藏
        document.addEventListener("visibilitychange", this.handleVisiable);
    },
    destroyed() {
        document.removeEventListener("visibilitychange", this.handleVisiable);
    },
    methods: {
        async loadList() {
            this.isLoading = true;
            let res = await api.getContinuityCareList(this.filter);
            if (res.code == 500) {
                return this.$router.push({
                    name: "Login",
                    query: { r: location.href },
                });
            }
            this.list.total = +res.total;
            this.list.current = this.filter.pageNumber;
            this.list.pageSize = Math.ceil(this.list.total / this.filter.pageSize);
            if (res.data) {
                res.data.forEach((item) => {
                    item.expectServiceTime = dayjs(item.expectServiceTime).format(
                        "YYYY-MM-DD"
                    );
                    item.cardNum = utils.hideIdCard(item.cardNum);
                });
                this.list.data = res.data;
            }
            this.isLoading = false;
        },
        // 过滤条件 更改
        handleFilter(key, val) {
            switch (key) {
                case 2:
                    if (this.filter.date) {
                        this.filter.expectServiceTimeStart = dayjs(
                            this.filter.date[0]
                        ).format("YYYY-MM-DD 00:00:00");
                        this.filter.expectServiceTimeEnd = dayjs(
                            this.filter.date[1]
                        ).format("YYYY-MM-DD 23:59:59");
                    } else {
                        this.filter.expectServiceTimeStart = "";
                        this.filter.expectServiceTimeEnd = "";
                    }
                    break;
            }
            this.filter.pageNumber = 1;
            this.loadList();
        },
        getUser() {
            return JSON.parse(localStorage.getItem("user")).data;
        },
        handleSizeChange(v) {
            this.filter.pageSize = v;
            this.filter.pageNumber = 1;
            this.loadList();
        },
        handleCurrentChange(v) {
            this.filter.pageNumber = v;
            this.loadList();
        },
        handleVisiable(e) {
            this.list.current=1
            // 关闭新开页面，回到列表页，刷新列表数据
            if (e.target.visibilityState == "visible") {
                this.loadList();
            }
        },
        // exportReport() {
        //     let url = api.exportOuthospitalReport(this.filter);
        //     const tempLink = document.createElement("a");
        //     tempLink.style.display = "none";
        //     tempLink.href = url;
        //     tempLink.target = "_blank";
        //     document.body.appendChild(tempLink);
        //     tempLink.click();
        //     document.body.removeChild(tempLink);
        // },
    },
};
</script>

<style lang="less" scoped>
@import "@/assets/style/var";

.user-not-found {
    position: absolute;
    top: 20px;
    right: 20px;
    z-index: 2;

    i {
        margin-right: 5px;
    }
}

.def-key {
    .el-checkbox {
        font-weight: 400;
        color: #808080;
    }
}
</style>
